import React from 'react';

export const FileIcon = () => {
    return (
        <svg
            width='36'
            height='36'
            viewBox='0 0 36 36'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <rect x='2' y='2' width='32' height='32' rx='16' fill='#99CFE0' />
            <rect
                x='2'
                y='2'
                width='32'
                height='32'
                rx='16'
                stroke='#E5F3F7'
                strokeWidth='4'
            />
            <path
                d='M19.3333 11.5117V14.2654C19.3333 14.6387 19.3333 14.8254 19.406 14.968C19.4699 15.0935 19.5719 15.1955 19.6973 15.2594C19.8399 15.332 20.0266 15.332 20.4 15.332H23.1537M23.3333 16.6575V21.4654C23.3333 22.5855 23.3333 23.1455 23.1153 23.5733C22.9236 23.9497 22.6176 24.2556 22.2413 24.4474C21.8134 24.6654 21.2534 24.6654 20.1333 24.6654H15.8666C14.7465 24.6654 14.1865 24.6654 13.7586 24.4474C13.3823 24.2556 13.0764 23.9497 12.8846 23.5733C12.6666 23.1455 12.6666 22.5855 12.6666 21.4654V14.532C12.6666 13.4119 12.6666 12.8519 12.8846 12.4241C13.0764 12.0477 13.3823 11.7418 13.7586 11.55C14.1865 11.332 14.7465 11.332 15.8666 11.332H18.0078C18.497 11.332 18.7416 11.332 18.9718 11.3873C19.1758 11.4363 19.3709 11.5171 19.5499 11.6268C19.7517 11.7504 19.9246 11.9234 20.2706 12.2693L22.396 14.3948C22.7419 14.7407 22.9149 14.9136 23.0386 15.1155C23.1482 15.2944 23.229 15.4895 23.278 15.6936C23.3333 15.9237 23.3333 16.1683 23.3333 16.6575Z'
                stroke='#0088B2'
                strokeWidth='1.33333'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};
